<template>
  <div id="pageContent">
    <TopBanner v-if="routeName !== 'playerDetail'" :bg-img="bgImg"
               :sub-title="mainTitle" />
    <div v-if="routeName !== 'playerDetail'" class="team-page">
      <div class="tab-box">
        <ul class="tab-btn-list">
          <li v-for="(tab, index) in tabList" :key="index" :class="{active: tab.name === routeName}">
            <router-link :to="{name: tab.name}">
              {{tab.title}}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <router-view class="contents"></router-view>
  </div>
</template>

<script>
import TopBanner from '@/components/Common/TopBanner.vue';

export default {
  name: 'PlayerView',
  components: {
    TopBanner
  },
  data() {
    return {
      tabList: [],
      bgImg: 'black', // playerList
      mainTitle: '프로',
    }
  },
  created() {
    const menuList = this.$router.options.routes && this.$router.options.routes.filter(x => {
      return x.path === this.$route.matched[0].path ? x : '';
    });

    const subMenuList = menuList[0].children && menuList[0].children.filter(x => {
      return x.meta && x.meta.title;
    });

    Object.entries(subMenuList).forEach(([, value]) => {
      const result = {
        title: value.meta.title,
        name: value.name,
        isActive: this.$route.name === value.name ? true : false
      }
      this.tabList.push(result);
    });
  },
  computed: {
    routeName() {
      return this.$route.name;
    }
  }
}
</script>
